import { createTheme, ThemeProvider } from "@mui/material"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import type {} from "@mui/x-date-pickers/themeAugmentation"
import ReactDOM from "react-dom/client"
import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"
import App from "./App"
import "./index.css"
import { config } from "./shared/config"

Sentry.init({
    dsn: "https://92bca6963d90463896dcb69673e09ec5@o283849.ingest.sentry.io/4504678354976768",
    integrations: [new BrowserTracing()],
    environment: config.env,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
})

const theme = createTheme({
    palette: {
        secondary: {
            main: "#2bb793",
        },
        primary: {
            main: "#4d3951",
        },
        mode: "light",
    },
    typography: {
        fontFamily: "Inter",
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    boxShadow: "none",

                    textTransform: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                    ...(ownerState.variant === "contained" &&
                        ownerState.color === "secondary" && {
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: "600",
                        }),
                }),
            },
            defaultProps: {
                variant: "contained",
                size: "large",
                color: "secondary",
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: "14px",
                    color: "#190A28",
                    fontWeight: "500",
                    lineHeight: "20px",
                    height: "48px",
                    fontFamily: "Fira Sans",
                },
                input: {
                    marginTop: "-3.5px",
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                endAdornment: {
                    top: "calc(50% - 14px)",
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: "16px",
                    color: "#190A28",
                    fontWeight: "500",
                    borderRadius: "4px",
                    lineHeight: "20px",
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "16px",
                    color: "#190A28",
                    fontWeight: "500",
                    lineHeight: "20px",
                    height: "48px",
                    fontFamily: "Fira Sans",
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: "0",
                    "&.Mui-error": {
                        color: "#CB2F67",
                    },
                },
            },
        },
        MuiCalendarPicker: {
            styleOverrides: {
                root: {
                    "& .Mui-selected": {
                        color: "#fff !important",
                    },
                },
            },
        },

        // confirm before commiting
        // MuiInputBase: {
        //     styleOverrides: {
        //         root: {
        //             height: "48px",
        //         },
        //         input: {
        //             height: "48px",
        //             padding: 0,
        //         },
        //     },
        // },
    },
})
ReactDOM.createRoot(document.getElementById("app") as HTMLElement).render(
    <ThemeProvider theme={createTheme(theme)}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App />
        </LocalizationProvider>
    </ThemeProvider>
)
